import React from 'react';

import FlexLink from '@components/FlexLink';
import { useCommentsContext } from '@contexts/CommentsContext';
import useCurrentUser from '@hooks/useCurrentUser';
import { user_dashboard_path } from '@routes';

import CommentForm from './';

const CommentFormContainer = () => {
  const { currentUser } = useCurrentUser();
  const { rootCommentableId, rootCommentableType } = useCommentsContext();

  return (
    <>
      {currentUser?.permitted_to_comment && (
        <CommentForm commentableId={rootCommentableId} commentableType={rootCommentableType} />
      )}
      {currentUser?.requires_name_to_comment && (
        <div className="commenting-profile-incomplete">
          Please add a name to{' '}
          <FlexLink href={user_dashboard_path()} toRailsPage>
            your profile
          </FlexLink>{' '}
          to begin commenting
        </div>
      )}
    </>
  );
};

export default CommentFormContainer;
